/**
 * Copyright 2020 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import { Box } from "../Box";
import { Button } from "../Button";
import { CardActions } from "../Card";

export type ActionsProps = {
  name: string;
  handler: () => void;
};

export type NotificationsActionsProps = {
  actions: ActionsProps[];
};

const NotificationsActions = ({ actions }: NotificationsActionsProps) => {
  return (
    <Box ml={-1}>
      <CardActions>
        {
          actions.map((item) => (
            <Button
              variant="outlined"
              onClick={item.handler}
              key={item.name}
            >
              {item.name}
            </Button>
          ))
        }
      </CardActions>
    </Box>
  );
};

export default NotificationsActions;
